import { Quote, Star } from "lucide-react";
import reviews from "@/content/reference.json";
import { CONTACT } from "@/content/site";
import { Reveal } from "@/components/Reveal";

// Sekce Reference — zobrazí se až po vložení skutečných recenzí do content/reference.json.
// Prázdné pole = sekce se veřejně nerenderuje (žádné vymyšlené ohlasy).
export const Reference = () => {
  if (!Array.isArray(reviews) || reviews.length === 0) return null;

  return (
    <section id="reference" data-testid="reference-section" className="py-24 md:py-32 border-t border-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Reference
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-[#252525] mt-6 max-w-2xl">
            Co říkají moji klienti
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 mt-16">
          {reviews.map((review, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <figure data-testid={`reference-item-${i}`} className="border-t border-[#E5E5E5] pt-8 h-full flex flex-col">
                <Quote className="h-6 w-6 text-[#B69A58]" strokeWidth={1} aria-hidden="true" />
                <blockquote className="text-base md:text-lg text-[#252525] leading-relaxed mt-6 font-display italic">
                  „{review.text}"
                </blockquote>
                <figcaption className="text-sm text-[#737373] mt-6">
                  {review.author}
                  {review.context && <span className="block text-xs mt-1">{review.context}</span>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        {CONTACT.googleReview && (
          <Reveal delay={0.1}>
            <div className="mt-16 border border-[#F0F0F0] p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10" data-testid="reference-google-cta">
              <span className="flex items-center justify-center w-12 h-12 border border-[#B69A58]/40 shrink-0">
                <Star className="h-5 w-5 text-[#B69A58]" strokeWidth={1.5} aria-hidden="true" />
              </span>
              <div className="flex-1">
                <h3 className="font-display text-xl md:text-2xl text-[#252525]">Spolupracovali jsme?</h3>
                <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed mt-2">
                  Vaše recenze na Googlu pomůže dalším lidem najít mě — a mně udělá radost.
                </p>
              </div>
              <a
                href={CONTACT.googleReview}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reference-google-button"
                className="inline-flex items-center justify-center border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-8 py-4 text-xs uppercase tracking-widest font-medium shrink-0"
              >
                Napsat recenzi na Google
              </a>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
};
